// extracted by mini-css-extract-plugin
module.exports = {"back":"styles-module__back___1_tLR","back-icon":"styles-module__back-icon___3e_Jl"};